import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-decision-bottom-sheet',
  templateUrl: './decision-bottom-sheet.component.html',
  styleUrls: ['./decision-bottom-sheet.component.css'],
  imports: [ CommonModule, MatButtonModule]
})
export class DecisionBottomSheetComponent {

  constructor(
    private bottomSheetRef: MatBottomSheetRef<DecisionBottomSheetComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: { sheetTitle: string, sheetText: string, sheetHtml: string }
  ) {}

  handleOK(): void {
    this.bottomSheetRef.dismiss(true);
  }

  handleCancel(): void {
    this.bottomSheetRef.dismiss(false);
  }
}
